export default __webpack_public_path__ + "static/Merriweather-Regular-55c73e48e04ec926ebfecb04ed87e53f.ttf";